import $ from "@modules/jquery";
import gsap from "@modules/gsap";
import { CustomEase } from "@modules/gsap/CustomEase";

export default function OffcanvasLayer() {
    const $body = $("body");
    const $toggleBtn = $(".offcanvasLoginButtonOpen");
    const $closeBtn = $("#offcanvasLoginButtonClose");
    const $layer = $("#offcanvas-layer");
    const $backdrop = $(".offcanvas-layer-backdrop");
    
    const customEase = "M0,0 C0.742,0 0.2,1 1,1";
    const lang = document.documentElement.lang || "it";

    gsap.registerPlugin(CustomEase);

    const labels = {
        it: { open: "Apri menu di navigazione", close: "Chiudi menu di navigazione" },
        de: { open: "Navigationsmenü öffnen", close: "Navigationsmenü schließen" },
    };

    function setAriaState($btn, isOpen) {
        $btn.attr("aria-expanded", String(isOpen));
        $btn.attr("aria-label", isOpen ? labels[lang].close : labels[lang].open);
    }
    function disableFocusInMenu() {
        if((!$layer || $layer.length === 0) || !$layer[0].querySelectorAll) {
            return; // Se $layer non è definito o non ha elementi, esci dalla funzione
        }
        $layer[0].querySelectorAll('a, button, input, textarea, select, [tabindex]')
        .forEach(el => {
        el.setAttribute('data-old-tabindex', el.getAttribute('tabindex')); // salva il valore originale
        el.setAttribute('tabindex', '-1');
        });
    }

    function enableFocusInMenu() {
        if((!$layer || $layer.length === 0) || !$layer[0].querySelectorAll) {
            return; // Se $layer non è definito o non ha elementi, esci dalla funzione
        }
        $layer[0].querySelectorAll('a, button, input, textarea, select')
        .forEach(el => {
            const oldTab = el.getAttribute('data-old-tabindex');
                if (oldTab !== null) {
                    el.setAttribute('tabindex', oldTab);
                    el.removeAttribute('data-old-tabindex');
                } else {
                    el.removeAttribute('tabindex');
                }
        });
    }
    // al primo ricaticamento della pagina disabilito il focus sugli elementi del menu
    disableFocusInMenu();

    

    function openLayer() {
        $layer.removeClass("not-display")
          enableFocusInMenu();
        gsap.to($layer, {
            duration: 1,
            right: 0,
            ease: CustomEase.create("custom", customEase),
            onStart: () => {
                $body.addClass("offcanvas-layer-activated");
                 enableFocusInMenu();
            }
        });

        gsap.fromTo($backdrop, {
            opacity: 0,
            pointerEvents: "none"
        }, {
            opacity: 1,
            duration: 0.3,
            pointerEvents: "auto"
        });
    }

    function closeLayer() {
        gsap.to($layer, {
            duration: 1,
            right: "-100%",
            ease: CustomEase.create("custom", customEase),
            onComplete: () => {
               
                $body.removeClass("offcanvas-layer-activated");
                disableFocusInMenu();
            }
        });

        gsap.to($backdrop, {
            opacity: 0,
            duration: 0.3
        });
    }

    function toggleLayer(isOpening) {
        setAriaState($toggleBtn, isOpening);

        if (isOpening) {
            openLayer();
            // Focus primo elemento interattivo
            $layer.find("a, button, input, [tabindex]:not([tabindex='-1'])").first().trigger("focus");
            const currentTab = localStorage.getItem("currentTab");
            if (currentTab !== null) {
                $("#tab-" + currentTab).click();
                if (currentTab === "business") {
                    const currentAccordion = localStorage.getItem("currentAccordion");
                    if (currentAccordion !== null && currentAccordion !== "") {
                        var accordion = "#tab-content-login #business #" + currentAccordion;
                        if ($(accordion).attr('aria-expanded') == "false") {
                            $(accordion).click();
                        }
                    }
                }
            }
        } else {
            closeLayer();
            $toggleBtn.trigger("focus"); // Ritorna focus al bottone apri
        }
    }

    $toggleBtn.on("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        toggleLayer(true)
    });
    
    $closeBtn.on("click", () => toggleLayer(false));
    $backdrop.on("click", () => toggleLayer(false)); // Chiudi anche cliccando sul backdrop

    $('#tab-private').on('click', () => {
        localStorage.setItem("currentTab", "private");
        localStorage.setItem("currentAccordion", "");
    });

    $('#tab-business').on('click', () => {
        localStorage.setItem("currentTab", "business");
    });

    $('#tab-content-login #business .accordion-trigger').on('click', function (elem) {
        var currentAccordion = $(this).attr("id");
        localStorage.setItem("currentAccordion", currentAccordion);
    });

    function resizeTabContentLogin() {
        const headerHeight = $('#offcanvas-login-header').first().outerHeight(true) || 0;
        const tabsHeight = $('#offcanvas-login-tabs').first().outerHeight(true) || 0;
    
        const totalOffset = headerHeight + tabsHeight;
        const availableHeight = window.innerHeight - totalOffset;
    
        $('#offcanvas-login-content').css('height', availableHeight + 'px');
    }

    $(window).on('resize', resizeTabContentLogin);
    resizeTabContentLogin();

    
}